import React from "react";
  import axios from 'axios';
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { useNavigate } from "react-router-dom";

  import { ToastContainer, toast } from 'react-toastify';
  import { NuDropdown } from "components/nubox/NuDropdown";
  import  NuEstado from "components/nubox/NuEstado";

  import { withRouterJim } from "router/withRouterJim";

  //---cutil
  import cUtilFecha from "helpers/cUtilFecha"
  import ModalDocente from "./ModalDocente";
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";


  const cbo=[
    {  value:'1', label: 'label1'},
  ]

  const data = [
    { id_paciente: 1,  nombre: 'ALEX LIZARRAGA', }, 
  ];

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class DocenteList extends React.Component {
    state = {

      modalActualizar: false,
      modalInsertar: false,
      form: {
        name: '',
      },
      data: data,/* lista de datos */
      estados: [
        { value: 0, label: "Inactivo", clase:'badge bg-secondary' },
        { value: 1, label: "Activo", clase:'badge bg-success' },
      ],
      
    };
     //--------------------------------------
    constructor(props) {
      super(props);

      this.modalRef = React.createRef();//create ref
      this.refNuConfirm = React.createRef();
    }
    //------------------
    
    //------------------------------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});

      this.cargar_data();
      
      //this.cargar_cbo();
    }

    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    
    //====================================================== 
    //----cargamos los datos desde la base de datos
    cargar_data = () => {
      let param = { 
        param1: this.state.form.name
      }
      
      axios2.post("docente_get_list", param)
      .then(res => {
          if(res.data.length>0){ 
              this.setState({data: res.data});
          }else{
              NotificationManager.error("No existen datos");
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    //--------------------------------------
    imprimir =(id_certi)=>{
      let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL,'',windowFeatures);
    }

    //-----------------------------------------------------------------
  nuevo = () => {
    this.modalRef.current.nuevo();
  }
  //-----------------------------------------------------------------
  editar = (item) =>{
    console.log('editar');
    //    console.log(item);
    let idd = item.id_doc;
    this.modalRef.current.editar(idd);
  }
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar.');
    
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        
        let idd = item.id_doc;
        this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data();
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //-------------------------------------
    //--------------------------------------
    
    /* === This is where the magic happens ==== */
    handleSubmit = event => {
      event.preventDefault();
      this.cargar_data();
    }
    //-------------
    onLinkClick = (e,item) => {
      e.preventDefault();
      this.props.navigate('/docente/e/'+ item.id_doc);
    };
    //-------------
   
    //=================== SAVE
    save =(idd, ope) =>{
        
      let param = { idd:idd, ope:ope };
      console.log(param);

      axios2.post("docente_store", param)
      .then(res => {
          console.log(res.data);
          if(res.data.exito === 1){ 
              toast.success(res.data.mensaje);
              
              this.cargar_data();            
          }else{
              toast.error(res.data.mensaje);
          }
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    }
    //-------------------------------------
    render() {
      
      return (
        <div>
          <ToastContainer />
          <NotificationContainer/>
          <div className="content">

            {/*<!--- ------------------------------->*/}
            <div className="row">
              <div className="col-md-12">
                <h3> Lista de docente

                  <div className="btn-group pull-right">

                    <Button onClick={() => this.nuevo()} 
                      className='create-modal btn btn-info ' >
                      <i className='fa fa-plus'></i> Nuevo 
                    </Button>
                  </div>
                </h3>
              </div>
            </div>

            <div className="row d-flex justify-content-center">
                <div className="box box-info">
                  {/*<!-- /.box-header -->*/}
                  <div className="box-body pad">

                    <form onSubmit = { this.handleSubmit }>
                      
                      <div className="row">

                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="control-label">Busqueda:</label>
                            <input type="text" 
                                name = "name" 
                                onChange= {this.handleChangeForm} 
                                className="form-control input-sm" />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <button type="submit" 
                              style={{ marginTop: "24px" }} 
                              className="btn btn-success ">
                              <i className="fa fa-binoculars"></i> Buscar</button>

                        </div>

                      </div>
                    </form>

                  </div>
                  {/*<!-- /.box-body -->*/}
                </div>
            </div>

            <div className="row">
                {/*<!-- box table -->*/}
                <div className="box">
                  <div className="box-header">
                    <br/>
                      <div className="col-md-12">


                        <div className="table-responsive">
                          <table className="table tabla_azul0 table-striped table-hover ">
                            <thead>
                              <tr>

                                <th>Cod. Doc.</th>
                                <th>C.I.</th>
                                <th>Nombre</th>
                                <th>Telf.</th>
                                <th>Foto</th>
                                <th>Estado</th>
                                <th className="text-center" style={{ width:"150px" }}>
                                  Acciones
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                          
                              {this.state.data.map((item,index) => (
                                <tr key={index}>
                                  <td>{ item.id_doc}</td>
                                  <td>{ item.nro_doc}</td>
                                  <td>{ item.nomape_tmp}</td>
                                  <td>{ item.tel}</td>
                                  <td>{ item.foto_path1}</td>
                                  <td>
                                    <NuEstado
                                       options={this.state.estados}
                                       name="estado"
                                       value={ item.estado }
                                    />
                                  </td>

                                  
                                  <td>
                                    <div className=''>
                                      <Button title="Editar" 
                                              className="btn btn-warning btn-sm"
                                              onClick={() => this.editar(item)} >
                                        <i className="fa fa-edit"></i>
                                      </Button>
                                      &nbsp;
                                      <Button className="btn btn-danger btn-sm" 
                                        title="Eliminar" 
                                        onClick={ ()=> this.eliminar(item) }  >
                                        <i className="fa fa-trash"></i> 
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                              

                            </tbody>
                            
                            </table>
                          
                        </div>

                      </div>


                  </div>
                </div>
                {/*<!-- fin box table -->*/}

            </div>

            
            {/*<!--- ----------------- form busqueda ------------------>*/}

            {/*<!-- -------------------------------------------------->*/}

          </div>
          <ModalDocente
                  ref={this.modalRef}
                  okModal={this.okModal}
                  closeModal={this.closeModal}
                />
          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(DocenteList);

